module.exports = __webpack_public_path__ + "img/TRAVEL-SC.f77ab2fd.jpg";